export function isIndexedDBAvailable(): boolean {
	try {
		// Do a indexedDB.databases check for Firefox incognito (indexedDB will exist but fail to open databases)
		return Boolean('indexedDB' in window) && Boolean(indexedDB?.databases());
	} catch (e) {
		return false;
	}
}
